import { combineReducers } from 'redux';

import fetchTripReducerMap, {
    fetchTripAction,
} from './actions/fetchTrip';
import fetchTripInformationReducerMap, {
    fetchTripInformationAction,
} from './actions/fetchTripInformation';
import fetchTripItineraryReducerMap, {
    fetchTripItineraryAction,
} from './actions/fetchTripItinerary';
import tripDataReducerMap, {
    actions as tripActions,
    schemas as tripSchemas,
    selectors as tripSelectors,
} from './appstate';
import NAMESPACE from './types';

const reducer = combineReducers({
    ...fetchTripReducerMap,
    ...fetchTripItineraryReducerMap,
    ...fetchTripInformationReducerMap,
    ...tripDataReducerMap,
});

export {
    fetchTripAction,
    fetchTripInformationAction,
    fetchTripItineraryAction,
    tripActions,
    tripSchemas,
    tripSelectors,
};

export default {
    [NAMESPACE]: reducer,
};
